"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRedirection = void 0;
const browser_tracker_1 = require("@snowplow/browser-tracker");
const url_1 = require("../../url/url");
/**
 * Track Redirection event in Snowplow.
 * v.0.18.1;
 * @public
 *
 * @param eventData - Object that contains event properties described in the Redirection document
 * (see https://healthcareinc.atlassian.net/l/cp/oE221wPW ).
 *
 * @example
 * ```ts
 *
 * import {trackRedirection} from '@hc-frontend/third-party-snowplow';
 *
 * trackRedirection({
 *   sourceCategory: 'landing',
 *   redirectType: 'organic',
 *   targetApplication: 'health-sherpa',
 *   targetUrl: 'https://quotes.healthcare.com/healthcare-insurance/survey/immediate_coverage/?journey_cro=141&zip=33133',
 *   sourceFunnel: 'health',
 *   description: '...',
 * });
 * ```
 */
function trackRedirection(eventData, contexts) {
    const { sourceCategory, redirectType, targetApplication, targetUrl, sourceFunnel, description, } = eventData;
    const { hostname, path, query } = (0, url_1.getUrlParts)(targetUrl);
    (0, browser_tracker_1.trackSelfDescribingEvent)({
        event: {
            schema: 'iglu:com.healthcare/redirection/jsonschema/1-0-5',
            data: {
                source_category: sourceCategory,
                redirect_type: redirectType,
                target_application: targetApplication,
                target_url_host: hostname,
                target_url_path: path,
                target_url_query: query,
                source_funnel: sourceFunnel,
                description,
            },
        },
        context: contexts,
    });
}
exports.trackRedirection = trackRedirection;
//# sourceMappingURL=redirection.js.map